import { cn } from 'app/lib/utils'
import { Loader2 } from 'lucide-react'

const LoadingAnimation = ({ className }: { className?: string }) => {
    return (
        <div className='flex h-full items-center justify-center' role='status' aria-label='Loading'>
            <Loader2
                className={cn(
                    'h-8 w-8 animate-spin text-primary motion-reduce:animate-none [[data-disporty-tenant=host]_&]:text-[#b4ff00]',
                    className
                )}
                strokeWidth={2}
                aria-hidden='true'
            />
        </div>
    )
}
export default LoadingAnimation
